// Central test IDs for the Imali app
export const NAV = {
  logo: "nav-logo-link",
  loans: "nav-loans-link",
  compare: "nav-compare-link",
  followups: "nav-followups-link",
  emailEvents: "nav-email-events-link",
  proposals: "nav-proposals-link",
  new: "nav-new-proposal-btn",
};

export const LANDING = {
  heroWriteGrant: "landing-cta-write-grant",
  heroApplyLoan: "landing-cta-apply-loan",
  featureCard: (i) => `landing-feature-${i}`,
};

export const LOANS = {
  industryCard: (id) => `loans-industry-card-${id}`,
  industryCta: (id) => `loans-industry-cta-${id}`,
};

export const LOAN_DETAIL = {
  page: (id) => `loan-detail-page-${id}`,
  generateCta: "loan-detail-generate-cta",
  amountRange: "loan-detail-amount-range",
  tenureRange: "loan-detail-tenure-range",
  rateRange: "loan-detail-rate-range",
  regionSelect: "loan-detail-region-select",
  regionCard: "loan-detail-region-card",
};

export const REGIONS = {
  select: "region-select",
  card: (id) => `region-card-${id}`,
};

export const BANKING = {
  section: "form-banking-section",
  toggle: "form-banking-toggle",
  bankName: "form-banking-bank-name",
  accountHolder: "form-banking-account-holder",
  identifier: "form-banking-identifier",
  swift: "form-banking-swift",
  branchCode: "form-banking-branch-code",
  notes: "form-banking-notes",
};

export const FORM = {
  root: "proposal-form-root",
  typeToggleLoan: "proposal-form-type-loan",
  typeToggleGrant: "proposal-form-type-grant",
  businessName: "proposal-form-business-name",
  industrySelect: "proposal-form-industry-select",
  regionSelect: "proposal-form-region-select",
  amount: "proposal-form-amount",
  currencySelect: "proposal-form-currency-select",
  tenure: "proposal-form-tenure",
  purpose: "proposal-form-purpose",
  annualRevenue: "proposal-form-annual-revenue",
  yearsInOp: "proposal-form-years-in-operation",
  useOfFunds: "proposal-form-use-of-funds",
  repaymentStrategy: "proposal-form-repayment-strategy",
  contactName: "proposal-form-contact-name",
  contactEmail: "proposal-form-contact-email",
  country: "proposal-form-country",
  projectTitle: "proposal-form-project-title",
  funderName: "proposal-form-funder-name",
  projectSummary: "proposal-form-project-summary",
  problemStatement: "proposal-form-problem-statement",
  objectives: "proposal-form-objectives",
  beneficiaries: "proposal-form-beneficiaries",
  submit: "proposal-form-submit",
};

export const PREVIEW = {
  page: "proposal-preview-page",
  title: "proposal-preview-title",
  content: "proposal-preview-content",
  copyBtn: "proposal-preview-copy-btn",
  downloadPdf: "proposal-preview-download-pdf",
  downloadDocx: "proposal-preview-download-docx",
  saveBtn: "proposal-preview-save-btn",
  backBtn: "proposal-preview-back-btn",
};

export const LIST = {
  page: "proposals-list-page",
  row: (id) => `proposals-list-row-${id}`,
  view: (id) => `proposals-list-view-${id}`,
  delete: (id) => `proposals-list-delete-${id}`,
  empty: "proposals-list-empty",
};

export const COMPARE = {
  page: "compare-page",
  businessName: "compare-business-name",
  industry: "compare-industry",
  amount: "compare-amount",
  currency: "compare-currency",
  tenure: "compare-tenure",
  revenue: "compare-revenue",
  purpose: "compare-purpose",
  addRegion: "compare-add-region",
  removeRegion: (i) => `compare-remove-region-${i}`,
  regionSelect: (i) => `compare-region-select-${i}`,
  suggestBar: "compare-suggest-bar",
  suggestApply: "compare-suggest-apply",
  suggestChip: (id) => `compare-suggest-chip-${id}`,
  whyRegion: (i) => `compare-why-region-${i}`,
  whyRegionPopover: (i) => `compare-why-region-popover-${i}`,
  copyActionable: "compare-copy-actionable",
  runBtn: "compare-run-btn",
  grid: "compare-grid",
  column: (i) => `compare-column-${i}`,
  advisorBtn: "compare-advisor-btn",
  advisorContent: "compare-advisor-content",
  downloadPdf: "compare-download-pdf",
  downloadDocx: "compare-download-docx",
  shareBtn: "compare-share-btn",
  shareUrl: "compare-share-url",
  stats: "compare-stats",
  statsTotal: "compare-stats-total",
  statsHuman: "compare-stats-human",
  statsBot: "compare-stats-bot",
  statsRefresh: "compare-stats-refresh",
  outreachOpen: (i) => `compare-outreach-open-${i}`,
  outreachDialog: "compare-outreach-dialog",
  outreachChannel: (name) => `compare-outreach-channel-${name}`,
  outreachTextarea: "compare-outreach-textarea",
  outreachRecipient: "compare-outreach-recipient",
  outreachCopy: "compare-outreach-copy",
  outreachSend: "compare-outreach-send",
  outreachSnooze: (n) => `compare-outreach-snooze-${n}`,
};

export const DIGEST = {
  panel: "digest-panel",
  shareSelect: "digest-share-select",
  email: "digest-email",
  timezone: "digest-timezone",
  hour: "digest-hour",
  save: "digest-save",
  unsubscribe: "digest-unsubscribe",
  preview: "digest-preview",
  previewDialog: "digest-preview-dialog",
  previewIframe: "digest-preview-iframe",
  history: "digest-history",
};

export const EMAIL_EVENTS = {
  page: "email-events-page",
  empty: "email-events-empty",
  shareSelect: "email-events-share-select",
  statCard: (kind) => `email-events-stat-${kind}`,
  timeline: "email-events-timeline",
  timelineRow: (id) => `email-events-timeline-row-${id}`,
  recipients: "email-events-recipients",
  recipientRow: (email) => `email-events-recipient-${email}`,
  refresh: "email-events-refresh",
  testTrigger: "email-events-test-trigger",
  testDialog: "email-events-test-dialog",
  testEventType: "email-events-test-event-type",
  testSend: "email-events-test-send",
};

export const FOLLOWUPS = {
  page: "followups-page",
  empty: "followups-empty",
  row: (id) => `followup-row-${id}`,
  done: (id) => `followup-done-${id}`,
  delete: (id) => `followup-delete-${id}`,
  reachout: (id) => `followup-reachout-${id}`,
  countBadge: "followups-count-badge",
};

export const SHARED = {
  page: "shared-comparison-page",
  title: "shared-comparison-title",
  grid: "shared-comparison-grid",
  column: (i) => `shared-comparison-column-${i}`,
  advisorContent: "shared-comparison-advisor",
  viewCount: "shared-comparison-view-count",
  ctaDraft: "shared-comparison-cta-draft",
};
